<!-- action btns -->
<!-- Note: the "Invite" button lives on the parent team pages (GLD + Workforce),
     which own the dialog and the Workforce seat-cap gating. This component
     intentionally renders no invite button to avoid a duplicate, ungated one. -->
<div
  class="tw-flex tw-gap-2 md:tw-gap-4 tw-flex-row tw-flex-wrap tw-items-center tw-my-4 tw-ml-[.1rem]">
  <button
    *ngIf="!isWorkforceMode"
    mat-raised-button
    [class.spinner]="refreshing"
    [disabled]="refreshing"
    (click)="refreshOrgUsers()"
    class="tw-flex-shrink-0">
    Refresh
  </button>
  <button
    *ngIf="canAdmin"
    mat-flat-button
    color="warn"
    [disabled]="!rowsSelected"
    (click)="removeSelectedUsers()"
    class="disabled:tw-border-gray-400 disabled:tw-text-gray-400 disabled:tw-cursor-not-allowed tw-flex-shrink-0">
    Remove Selected Users
  </button>
</div>

<!-- ag-grid table -->
<div class="tw-overflow-x-auto tw-max-w-[1200px]">
  <div class="tw-min-w-[1000px] tw-w-full">
    <ag-grid-angular
      style="width: 100%;"
      [ngClass]="{ 'ag-theme-quartz': !(darkModeService.darkMode$ | async), 'ag-theme-quartz-dark': darkModeService.darkMode$ | async }"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="tooltipShowDelay"
      accentedSort="true"
      [components]="components"
      [rowSelection]="rowSelection"
      [selectionColumnDef]="{ width: 50, minWidth: 50, maxWidth: 50, suppressHeaderMenuButton: true }"
      [defaultColDef]="defaultColDef"
      enableCellTextSelection="true"
      ensureDomOrder="true"
      domLayout="autoHeight"
      (gridReady)="onGridReady($event)"
      [readOnlyEdit]="true"
      (cellEditRequest)="updateUser($event)"
      (selectionChanged)="onSelectionChanged($event)">
    </ag-grid-angular>
  </div>
</div>
